<ul class="content-blocks">
  @for (block of blocks; track block.id) {
    <li [class.d-none]="block.hideOnMobile" [class.d-md-block]="block.hideOnMobile" [class.d-md-none]="block.hideOnDesktop">
      @switch (block.blockType) {
        @case ('featured-collection') {
          <app-content-block-featured-collection
            [block]="block"
            [ngClass]="block?.colorTheme || ''"
          ></app-content-block-featured-collection>
        }
        @case ('featured-products') {
          <app-content-block-featured-products [block]="block" [ngClass]="block?.colorTheme || ''"></app-content-block-featured-products>
        }
        @case ('wysiwyg') {
          <app-content-block-wysiwyg
            [block]="block"
            [cookies]="(cookiePreferences$ | async) ?? undefined"
            [ngClass]="block?.colorTheme || ''"
          ></app-content-block-wysiwyg>
        }
        @case ('with-images') {
          <app-content-block-with-images
            class="d-block content-block-with-images section-outset-y"
            [block]="block"
            [cookies]="(cookiePreferences$ | async) ?? undefined"
            [ngClass]="block?.colorTheme ? block.colorTheme + ' section-inset-y has--theme' : ''"
          ></app-content-block-with-images>
        }
        @case ('featured-collection-products') {
          <app-content-block-product-catalog [block]="block" [ngClass]="block?.colorTheme || ''"></app-content-block-product-catalog>
        }
        @case ('faq') {
          <app-content-block-faq [block]="block" [cookies]="(cookiePreferences$ | async) ?? undefined"></app-content-block-faq>
        }
        @case ('instagram-feed') {
          @if (instaPosts$ | async; as instaPosts) {
            @if (instaPosts?.length) {
              <app-content-block-instagram-feed [block]="block">
                <app-instagram-feed [posts]="instaPosts ?? []"></app-instagram-feed>
              </app-content-block-instagram-feed>
            }
          }
        }
      }
    </li>
  }
</ul>
